import React from 'react';

export interface ILayoutRouteProps {
  component: React.ComponentType<any>;
  layout: React.ComponentType<any>;
}

export const LayoutRoute = ({ layout: Layout, component: Component }: ILayoutRouteProps) => {
  return (
    <Layout>
      <Component />
    </Layout>
  );
};
